import { parseMcleodDate } from "../utils/dateHelpers";

export default class DocumentSerializer {
  static serialize(data) {
    return {
      ...data
    };
  }

  static deSerialize(data) {
    return {
      ...data,
      uploadDate: parseMcleodDate(data.scanDate)
    };
  }
}